/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


const getTransform = (props) =>
{
  return getRotate(props) + ' ' + getTranslate(props);
}


const getRotate = ({ borderGeometry }) =>
{
  return `rotate(${borderGeometry.getRotationDegrees()})`;
}


const getTranslate = ({ borderGeometry, external }) =>
{
  const triangle = external ? borderGeometry.getExternal() : borderGeometry.getCurrent();

  return `translate(${- borderGeometry.getCenterToPartitionDistance(triangle)}, 0)`
}


const Component = ({ Component, ...props }) =>
(
  <g transform = {getTransform(props)} >
    <Component {...props} />
  </g>
);


export default (props) =>
{
  const { geometry, location, index } = props;

  return <Component {...props} borderGeometry = {geometry.getZone(location).getBorders()[index]} />;
}
